import { t } from 'i18next';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { SimpleButton } from '../../../common/Buttons';
import { InputField } from '../../../common/Inputs';
import { Column, Row } from '../../../common/LayoutComponents';
import { ExternalLinksFormState } from './schema';

const testIds = {
  name: 'ExternalLinksFormFields::name',
  location: 'ExternalLinksFormFields::location',
  deleteExternalLink: 'ExternalLinksFormFields::deleteExternalLink',
};

type ExternalLinksFormFieldsProps = {
  readonly index: number;
  readonly onRemove: (index: number) => void;
  readonly toBeDeleted: boolean;
};

export const ExternalLinksFormFields: FC<ExternalLinksFormFieldsProps> = ({
  index,
  onRemove,
  toBeDeleted,
}) => {
  const { register } = useFormContext<ExternalLinksFormState>();

  return (
    <Column className="w-full gap-4">
      <Row className="flex w-full items-end gap-4">
        <InputField<ExternalLinksFormState>
          type="string"
          translationPrefix="stopDetails"
          fieldPath={`externalLinks.${index}.name`}
          className="min-w-0 grow"
          inputClassName="w-full"
          testId={testIds.name}
          disabled={toBeDeleted}
          required
        />
        <SimpleButton
          shape="round"
          testId={testIds.deleteExternalLink}
          onClick={() => onRemove(index)}
          inverted
          tooltip={
            toBeDeleted
              ? t(($) => $.stopDetails.externalLinks.cancelDeleteExternalLink)
              : t(($) => $.stopDetails.externalLinks.deleteExternalLink)
          }
          className="h-11"
        >
          {toBeDeleted ? (
            <i className="icon-restore -ml-2.5 text-2xs" aria-hidden />
          ) : (
            <i className="icon-trash text-lg" aria-hidden />
          )}
        </SimpleButton>
      </Row>
      <Row className="flex w-full items-end">
        <InputField<ExternalLinksFormState>
          type="url"
          translationPrefix="stopDetails"
          fieldPath={`externalLinks.${index}.location`}
          className="w-full"
          inputClassName="w-full"
          testId={testIds.location}
          disabled={toBeDeleted}
          required
        />
      </Row>
      <input
        type="checkbox"
        hidden
        {...register(`externalLinks.${index}.toBeDeleted`)}
      />
    </Column>
  );
};
